const IMPERSONATED_USER_STORAGE_KEY = 'weavr.impersonatedUserId';
export const IMPERSONATED_USER_HEADER = 'X-Weavr-Impersonated-User-Id';

export const getImpersonatedUserId = () => window.localStorage.getItem(IMPERSONATED_USER_STORAGE_KEY);

export const setImpersonatedUserId = (userId: string | null) => {
  if (userId) window.localStorage.setItem(IMPERSONATED_USER_STORAGE_KEY, userId);
  else window.localStorage.removeItem(IMPERSONATED_USER_STORAGE_KEY);
};
